export class User {
  readonly id: number;
  readonly nickname: string;
  readonly firstname: string;
  readonly lastname: string;
  readonly email: string;
  readonly color: string;
  readonly phone_fixed: string;
  readonly phone_mobile: string;
  readonly is_superadmin: boolean;

  constructor(data: any) {
    this.id = data.id;
    this.nickname = data.nickname;
    this.firstname = data.firstname;
    this.lastname = data.lastname;
    this.email = data.email;
    this.color = data.color;
    this.phone_fixed = data.phone_fixed;
    this.phone_mobile = data.phone_mobile;
    this.is_superadmin = data.is_superadmin;
  }
}
